<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.review.actions.reply.title')"
    :info="$t('components.review.actions.reply.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'success', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="pt-4 text-left">
      <o-field-group>
        <text-area-field v-model="reply" :label="$t('review.reply')" :info="$t('components.review.actions.reply.replyInfo')" />
      </o-field-group>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { TextAreaField } from '@/components/fields'

import type { Review } from '~/_api/models/review'

interface Props {
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'update:review', value: Review): void
  (e: 'error'): void
}

withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const review = ref<Review | null>(null)
const reply = ref('')

const open = (item: Review) => {
  review.value = item
  reply.value = (item as any).reply ?? ''

  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.review.respond(review.value!, reply.value)

    if (response.data) {
      emit('success')
      emit('update:review', response.data)

      $notification.toast({
        title: $i18n.t('components.review.actions.reply.success'),
        text: $i18n.t('components.review.actions.reply.successInfo'),
      })

      return true
    }
  } catch (e: any) {
    console.log(e)

    emit('error')
    $notification.error({ errors: e?.errors })
  }
}

defineExpose({ open })
</script>
